import { FC } from 'react'
import { PageContent } from 'components/common/Page/PageContent'
import { Stack } from '@mui/material'
import { DangerZoneModule } from 'components/pages/Workspace/DangerZone'
import { WorkspaceCCEmailsModule } from 'components/pages/Workspace/WorkspaceCCEmails'
import { WorkspaceInformationModule } from 'components/pages/Workspace/WorkspaceInformation'

export const WorkspaceInformationContent: FC = () => {
  return (
    <PageContent>
      <Stack gap="4.6rem" padding="5.6rem 0">

        <WorkspaceInformationModule />

        <WorkspaceCCEmailsModule />

        <DangerZoneModule />

      </Stack>
    </PageContent>
  )
}
